import {AccessibleSpinner} from "./AccessibleSpinner";

export const Loading = () =>
{
    return (
        <div>
            <AccessibleSpinner show={true} className="me-2"/>Loading...
        </div>
    )
}
